import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var MapFloorPlansWithUnits = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-MapFloorPlansWithUnits',
	};

	$.extend(true, this.options, options);

};

MapFloorPlansWithUnits.prototype.init = function() {

	var self = this;

	this.activeFloor = 1;
	this.activePopupId = null;
	this.goToFloorTimeline = null;
	this.popupAnimation = null;

	this.$floorSelectors = this.options.$el.find(`.${self.options.baseClass}__floorSelector`);

	this.initUnitPopups();

	this.animateIn();

	this.$floorSelectors.on('click', function() {

		if (!$(this).hasClass(`${self.options.baseClass}__floorSelector--active`)) {
			var floorId = $(this).data('floorId');
			self.goToFloor(floorId);
		}

	});

	this.options.$el.find(`.${self.options.baseClass}__button--details`).on('click', function() {

		var unitId = $(this).data('unitId');

		self.showUnitModal(unitId);

	});

	// if unit url parameter exists, open modal on page load
	var currentUrl = window.location.href;
	
	if (currentUrl.indexOf("unitDetail")) {

		var urlSegments = currentUrl.split('?');

		if (urlSegments.length > 1) {

			var urlParameters = urlSegments[1].split('&');

			for (var i = 0; i < urlParameters.length; i++) {
				
				if (urlParameters[i].indexOf("unitDetail") == 0) {

					var unitId = urlParameters[i].split('=')[1];

					// make sure we don't open our modal onload from multiple components
					if (!window.unitDetailOpenedOnload) {
						console.log('MapFloorPlansWithUnits:showmodal');
						window.unitDetailOpenedOnload = true;
						self.showUnitModalWhenLoaded(unitId);
					}

				}

			}

		}

	}


};

MapFloorPlansWithUnits.prototype.showUnitModalWhenLoaded = function(unitId) {

	var self = this;

	if (!window.modalUnitDetailLoaded) {

		setTimeout(function() {
			self.showUnitModalWhenLoaded(unitId);
		}, 50);
		
	}
	else {

		self.showUnitModal(unitId);

	}

};

MapFloorPlansWithUnits.prototype.goToFloor = function(floorId) {

	var self = this;

	// kill our animation in case it's still running from before
	if (this.goToFloorTimeline) {
		this.goToFloorTimeline.progress(1);
	}

	var $allPopupMarkers = self.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`);

	var $oldActiveImage = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${self.activeFloor}"] .${self.options.baseClass}__floorPlanImage`);
	var $oldActiveContainer = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${self.activeFloor}"]`);

	var $newActiveFloorSelector = self.options.$el.find(`.${self.options.baseClass}__floorSelector[data-floor-id="${floorId}"]`);
	var $newActiveFloorSelectorUnderline = $newActiveFloorSelector.find(`.${self.options.baseClass}__floorSelector__underline`);
	var $newActiveImage = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floorId}"] .${self.options.baseClass}__floorPlanImage`);
	var $newActiveContainer = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floorId}"]`);
	var $newActivePopupMarkers = $newActiveContainer.find(`.${self.options.baseClass}__unitPopupMarker`);

	this.goToFloorTimeline = gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
			}
		}
	)
	// .timeScale(0.5)
	// we're handling colors using an active class so that we can keep all colors at the top of the scss file
	.add( function() {
			self.$floorSelectors.removeClass(`${self.options.baseClass}__floorSelector--active`);
			$newActiveFloorSelector.addClass(`${self.options.baseClass}__floorSelector--active`);
	} )
	// fade out currently active floor underline
	.to(self.options.$el.find(`.${self.options.baseClass}__floorSelector:not([data-floor-id="${floorId}"]) .${self.options.baseClass}__floorSelector__underline`),
		{
			duration: 0.3,
			opacity: 0,
		},
		"0"
	)
	// update newly active floor underline
	.set($newActiveFloorSelectorUnderline,
		{
			opacity: 1
		},
		"0"
	)
	.fromTo($newActiveFloorSelectorUnderline,
		{
			right: "100%"
		},
		{
			duration: 1,
			right: "0%",
		},
		"0"
	)
	// old image
	.fromTo($oldActiveImage,
		{
			opacity: 1,
		},
		{
			duration: 0.3,
			opacity: 0
		},
		"0"
	)
	// old popup markers
	.fromTo($allPopupMarkers,
		{
			opacity: 1,
		},
		{
			duration: 0.3,
			opacity: 0,
		},
		"0"
	)
	.set($oldActiveContainer,
		{
			display: "none"
		},
		">"
	)
	.addLabel("oldFloorPlanHidden", ">")
	// update newly active floor plan image
	.set($newActiveContainer,
		{
			display: "block"
		},
		"oldFloorPlanHidden"
	)
	.fromTo(self.options.$el,
		{
			height: self.options.$el.outerHeight()
		},
		{
			duration: 0.3,
			height: "auto"
		},
		">"
	)
	.addLabel("heightAdjusted", ">")
	.add( function() {
		self.positionUnitPopups(floorId);
	}, "heightAdjusted" )
	// image
	.fromTo($newActiveImage,
		{
			scale: 1.05,
			opacity: 0
		},
		{
			duration: 0.8,
			scale: 1,
			opacity: 1
		},
		"heightAdjusted"
	)
	// unit popup markers
	.set($newActivePopupMarkers,
		{
			xPercent: -50
		},
		"heightAdjusted"
	)
	.fromTo($newActivePopupMarkers,
		{
			opacity: 0,
			scale: 0,
			yPercent: 25,
		},
		{
			immediateRender: false,
			duration: 0.4,
			opacity: 1,
			scale: 1,
			yPercent: -50,
			y: 0,
			stagger: {
				each: 0.08
			}
			//ease: "power1.out",
		},
		"heightAdjusted"
	)
	.add( function() {
		self.activeFloor = floorId;
	} )
	;
};

MapFloorPlansWithUnits.prototype.animateIn = function() {

	var self = this;

	// animate in when component is in viewport
	gsap.timeline(
		{
			scrollTrigger: {
				trigger: self.options.$el,
				start: '75% bottom',
				end: '50% top',
				// markers: true,
			},
			delay: 0,
		}
	)
	.to(self.options.$el.find(`.${self.options.baseClass}__floorSelector[data-floor-id="1"] .${self.options.baseClass}__floorSelector__underline`),
		{
			duration: 1,
			ease: "power1.out",
			right: "0%",
		}
	)
	.to(self.options.$el.find(`.${self.options.baseClass}__floorPlanImage`),
		{
			duration: 0.8,
			ease: "power1.out",
			scale: 1,
			//ease: "power1.out",
		},
		"<"
	)
	.to(self.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`),
		{
			duration: 0.4,
			ease: "power1.out",
			opacity: 1,
			scale: 1,
			yPercent: -50,
			y: 0,
			stagger: {
				each: 0.08
			}
			//ease: "power1.out",
		},
		"<"
	);

};

MapFloorPlansWithUnits.prototype.initUnitPopups = function() {

	var self = this;

	this.positionUnitPopups(1);

	$(window).on('load', function() {
		self.positionUnitPopups(1);
	});

	PubSub.subscribe("resized", function(){
		self.positionUnitPopups(self.activeFloor);
	});

	this.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`).on({

		// open popup on hover on all screen sizes
		// note: hover is the same as click on mobile
		mouseenter: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{

				var $popup = $( '#' + $(this).data('popupId') );

				self.showPopup($popup);

			}

		},

		// only close on mouse leave for large screens,
		// for mobile we will use the close X
		mouseleave: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{
				var $popup = $( '#' + $(this).data('popupId') );

				if (!$popup.is(':hover'))
				{
					self.hidePopup($popup);
				}

			}

		},

		// react to click event
		click: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{
				var $popup = $( '#' + $(this).data('popupId') );
				self.showPopup($popup);
			}
			else
			{
				var unitId = $(this).data('unitId');
				self.showUnitModal(unitId);
			}

		}

	});

	this.options.$el.find(`.${self.options.baseClass}__unitPopupWrapper`).on({

		// only close on mouse leave for large screens,
		// for mobile we will use the close X
		mouseleave: function() {

			if (Breakpoint.value == "medium" ||
				Breakpoint.value == "large" ||
				Breakpoint.value == "xlarge" ||
				Breakpoint.value == "xxlarge")
			{
				var $popupMarker = $( `.${self.options.baseClass}__unitPopupMarker` + '[data-popup-id="' + $(this).attr('id') + '"]');

				if (!$popupMarker.is(':hover'))
				{
					// $(this).removeClass(`${self.options.baseClass}__unitPopupWrapper--active`);
					// $popupMarker.removeClass(`${self.options.baseClass}__unitPopupMarker--active`);
					self.hidePopup($(this));
				}
			}

		}

	});

	// on mobile, close the info popup when the close X is clicked
	// this.options.$el.find(`.${self.options.baseClass}__unitPopupWrapper .${self.options.baseClass}__closeX`).on('click', function() {

	// 	if (Breakpoint.value == "xsmall" ||
	// 		Breakpoint.value == "small")
	// 	{
	// 		var $popupWrapper = $(this).closest(`.${self.options.baseClass}__unitPopupWrapper`);
	// 		var popupId = $popupWrapper.attr('id');
	// 		var $popupMarker = $(`.${self.options.baseClass}__unitPopupMarker` + '[data-popup-id="' + popupId + '"]');

	// 		$popupWrapper.removeClass(`${self.options.baseClass}__unitPopupWrapper--active`);
	// 		$popupMarker.removeClass(`${self.options.baseClass}__unitPopupMarker--active`);
	// 	}

	// });

};

MapFloorPlansWithUnits.prototype.showPopup = function($popup) {

	var self = this;

	if (this.activePopupId != $popup.attr('id')) {

		this.activePopupId = $popup.attr('id');

		if (this.popupAnimation) {
			this.popupAnimation.progress(1);
		}

		this.popupAnimation = gsap.timeline(
			{
				defaults: {
					ease: "power1.out",
				}
			}
		)
		.set($popup,
			{
				zIndex: 2,
				visibility: "visible"
			}
		)
		.fromTo($popup,
			{
				y: -10,
				opacity: 0
			},
			{
				duration: 0.3,
				y: 0,
				opacity: 1
			}
		)
		;

	}

};

MapFloorPlansWithUnits.prototype.hidePopup = function($popup) {

	var self = this;

	this.activePopupId = null;

	if (this.popupAnimation) {
		this.popupAnimation.progress(1);
	}

	this.popupAnimation = gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
			}
		}
	)
	.fromTo($popup,
		{
			opacity: 1
		},
		{
			duration: 0.3,
			opacity: 0
		}
	)
	.set($popup,
		{
			zIndex: -1,
			visibility: "hidden"
		}
	)
	;

};

MapFloorPlansWithUnits.prototype.showUnitModal = function(unitId) {

	var self = this;
console.log('calling open modal');
	// open up the modal in loading state
	PubSub.publish('ModalUnitDetail:open', unitId);

	// put together our graph ql query
	var query = `
	query MyQuery {
		entry(section: "units", id: "` + unitId + `") {
			... on units_unit_Entry {
				id
				url
				unitActive
				unitBeds
				unitBaths
				unitSquareFeet
				unitCost
				title
				unitApplicationFee
				unitSecurityDeposit
				unitPetPolicies {
					... on unitPetPolicies_petPolicy_BlockType {
						petPolicyText
					}
				}
				unitAvailability
				unitAmenities {
					... on unitAmenities_amenity_BlockType {
						amenityText
					}
				}
				unitApplyUrl
				unitYoutubeVideoId
				unitImages {
					srcset: url @imagerSrcset (handle: "unitModalImage")
				}
			}
		}
	}
	`;

	// run the ajax query that gets our unit data
	$.ajax({

		type: 'POST',
		url: '/api',
		data: { query: query },

		success: function(data) {

			// console.log('success');
			// console.log(data.data.entry);

			if (!data.data.entry) {
				PubSub.publish('ModalUnitDetail:notFound');
				return;
			}

			PubSub.publish('ModalUnitDetail:populateContent', data.data.entry);

			// var entry = data.data.entry;

			// var imageUrls = [];
			// for (var i = 0; i < entry.projectFeaturedImages.length; i++)
			// {
			// 	imageUrls.push(entry.projectFeaturedImages[i].url);
			// }

			// var title = entry.title;;
			// var textContent = entry.projectSummary;
			// var url = entry.url;

			// // populate the pane, if it's active then wait until fade out to populate
			// window.setTimeout(function() {
			// 	self.populateDetailPane(imageUrls, title, textContent, url);
			// }, 300);

		},

		error: function(data) {
			console.log('ajax error');
			console.log(data);
		},

	});

};

MapFloorPlansWithUnits.prototype.hideUnitModal = function() {

	var self = this;

};

MapFloorPlansWithUnits.prototype.positionUnitPopups = function(floor) {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floor}"] .${self.options.baseClass}__unitPopupWrapper`).each(function() {

		var $popupMarker = $(this).prev();

		// reset everything
		$(this).find(`.${self.options.baseClass}__arrow`).css('left', '');
		$(this).removeClass(`${self.options.baseClass}__unitPopupWrapper--arrowFlipped`);
		$(this).css({
			'left': '',
			'top': '',
		});
		$(this).find(`.${self.options.baseClass}__arrow`).css({
			'left': '',
		});

		if (Breakpoint.value == "medium" ||
			Breakpoint.value == "large" ||
			Breakpoint.value == "xlarge" ||
			Breakpoint.value == "xxlarge")
		{
			// get our bounding rectangles
			var heightContainerBoundingRect = self.options.$el[0].getBoundingClientRect();
			var containerBoundingRect = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floor}"]`)[0].getBoundingClientRect();

			var popupBoundingRect = $(this)[0].getBoundingClientRect();

			var popupTopAdjust = popupBoundingRect.height - 6 + ($popupMarker.outerHeight() / 2); // subtract 6 so popup intersects marker
			var popupHalfWidth = popupBoundingRect.width / 2; // 

			// initial popup position
			$(this).css({
				'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px)',
				'top': 'calc(' + $(this).data('y') + '% - ' + popupTopAdjust + 'px)',
			});
			
			// after initial positioning, update the popup bounding rectangle
			popupBoundingRect = $(this)[0].getBoundingClientRect();

			// make sure our popup is still contained inside the component

			// left side
			if (popupBoundingRect.left < containerBoundingRect.left)
			{

				// the popup is outside the left edge, adjust to move it back in
				var leftAdjust = containerBoundingRect.left - popupBoundingRect.left + 6;

				$(this).css({
					'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px + ' + leftAdjust + 'px)',
				});

				// adjust the arrow so it still points to the marker
				$(this).find(`.${self.options.baseClass}__arrow`).css({
					'left': 'calc(50% - 14px - ' + leftAdjust + 'px)',
				});

			}

			// right side
			if (popupBoundingRect.right > containerBoundingRect.right)
			{

				// the popup is outside the right edge, adjust to move it back in
				var rightAdjust = popupBoundingRect.right - containerBoundingRect.right + 6;

				$(this).css({
					'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px - ' + rightAdjust + 'px)',
				});

				// adjust the arrow so it still points to the marker
				$(this).find(`.${self.options.baseClass}__arrow`).css({
					'left': 'calc(50% - 14px + ' + rightAdjust + 'px)',
				});

			}

			// top
			if ((popupBoundingRect.top - 20) < heightContainerBoundingRect.top) // subtract ten from bounding rect to account for translateY
			{

				// the popup is outside the top edge, adjust to move it back in

				// flip the arrow so it points up
				$(this).addClass(`${self.options.baseClass}__unitPopupWrapper--arrowFlipped`);

				var popupTopAdjust = ($popupMarker.outerHeight() / 2) - 6; // subtract 6 so popup intersects marker

				// use percentage, pull down 8px to give some space around marker
				$(this).css({
					'top': 'calc(' + $(this).data('y') + '% + ' + popupTopAdjust + 'px)',
				});

			}

		}

	});

};

export default MapFloorPlansWithUnits;
